export default __webpack_public_path__ + "static/media/settingsGrey.5a2f90aa.svg";